import { useState } from "react";

import { Button } from "@blueprintjs/core";
import { toast } from "sonner";

import {
  ReviewSidebarDocument,
  useReturnReviewRevisionMutation,
} from "@/graphql";

export function MarkRevisedButton({ id }: { id: string }) {
  const [completing, setCompleting] = useState(false);
  const [mutate] = useReturnReviewRevisionMutation({
    variables: {
      reviewId: id,
    },
    refetchQueries: [{ query: ReviewSidebarDocument, variables: { id: id } }],
    awaitRefetchQueries: true,
    onCompleted: (data) => {
      setCompleting(false);
      if (data.returnReviewRevision?.errors?.[0]) {
        toast.error(data.returnReviewRevision.errors[0].message);
      }
    },
    onError: () => {
      setCompleting(false);
    },
  });

  return (
    <Button
      intent="primary"
      text="Revision Sent"
      large={true}
      loading={completing}
      disabled={completing}
      onClick={() => {
        setCompleting(true);
        mutate();
      }}
    />
  );
}
